// initProductRecommendationsAndSliders();
function initProductRecommendationsAndSliders() {
  const rec = document.querySelector('.product-recommendations');
  const loadURL = rec?.dataset.url;

  function initializeSliders() {
    document.querySelectorAll('[id^="customCollectionSlider-"]').forEach(container => {
      const desk = parseFloat(container.getAttribute('data-desktop'));
      const mob = parseFloat(container.getAttribute('data-mobile'));
      const swiperContainer = container.querySelector('.collectionSlider');
      const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
      const next = container.querySelector(".swiper-button-next");
      const prev = container.querySelector(".swiper-button-prev");
      const pagination = container.querySelector(".swiper-pagination");
      const section = container.closest('section.customCollectionSlider');

      function updateGrad() {
        const isArabic = window.location.pathname.includes('/ar');
        if (isArabic) {
          section.style.setProperty('--show-after', next.classList.contains('swiper-button-disabled') ? 'none' : 'block');
          section.style.setProperty('--show-before', prev.classList.contains('swiper-button-disabled') ? 'none' : 'block');
        } else {
          section.style.setProperty('--show-before', next.classList.contains('swiper-button-disabled') ? 'none' : 'block');
          section.style.setProperty('--show-after', prev.classList.contains('swiper-button-disabled') ? 'none' : 'block');
        }
      }
      

      function checkAndCenterSlides(swiperInstance) {
        const totalSlides = swiperInstance.slides.length;
        const slidesPerView = swiperInstance.params.slidesPerView;
        
        // Check if slides don't overflow
        if (totalSlides <= slidesPerView) {
          swiperWrapper.style.justifyContent = 'center';
          // Hide navigation and pagination
          if (next) next.style.display = 'none';
          if (prev) prev.style.display = 'none';
          if (pagination) pagination.style.display = 'none';
          
          // Hide gradients when centered
          section.style.setProperty('--show-before', 'none');
          section.style.setProperty('--show-after', 'none');
        } else {
          swiperWrapper.style.justifyContent = '';
          // Show navigation and pagination
          if (next) next.style.display = '';
          if (prev) prev.style.display = '';
          if (pagination) pagination.style.display = '';
          
          // Update gradients normally
          updateGrad();
        }
      }

      const swiper = new Swiper(swiperContainer, {
        slidesPerView: mob,
        spaceBetween: 16,
        slidesPerGroup: 2,
        speed: 500,
        effect: "slide",
        navigation: { nextEl: next, prevEl: prev },
        pagination: { el: pagination, clickable: true },
        breakpoints: { 
          767: { 
            slidesPerView: desk, 
            slidesPerGroup: 3, 
            spaceBetween: 24 
          } 
        },
        on: { 
          init: function() {
            updateGrad();
            checkAndCenterSlides(this);
          },
          slideChange: function() {
            updateGrad();
            checkAndCenterSlides(this);
          },
          reachEnd: function() {
            updateGrad();
            checkAndCenterSlides(this);
          },
          reachBeginning: function() {
            updateGrad();
            checkAndCenterSlides(this);
          },
          resize: function() {
            checkAndCenterSlides(this);
          }
        }
      });
    });

    setTimeout(() => {
      document.querySelectorAll('[id^="customCollectionSlider-"]').forEach(c => {
        const wrap = c.querySelector('.swiper-wrapper');
        const cont = c.querySelector('.collectionSlider');
        const nextBtn = c.querySelector('.swiper-button-next');
        const totalSlides = wrap.children.length;
        const slidesPerView = window.innerWidth >= 767 ? 
          parseFloat(c.getAttribute('data-desktop')) : 
          parseFloat(c.getAttribute('data-mobile'));
        
        // Only enable navigation if slides overflow
        if (wrap.scrollWidth > cont.clientWidth && totalSlides > slidesPerView) {
          nextBtn.classList.remove('swiper-button-disabled', 'swiper-button-lock');
        }
      });
    }, 1000);

    document.querySelectorAll('.customPrdBox').forEach(box => {
      const imgBox = box.querySelector('.imageWrapper .imageBox');
      const prev = box.querySelector('.imageWrapper .iconWrapper svg:first-child');
      const next = box.querySelector('.imageWrapper .iconWrapper svg:last-child');

      if (imgBox && prev && next) {
        next.addEventListener('click', e => {
          e.preventDefault();
          imgBox.scrollBy({ left: imgBox.clientWidth, behavior: 'smooth' });
        });

        prev.addEventListener('click', e => {
          e.preventDefault();
          imgBox.scrollBy({ left: -imgBox.clientWidth, behavior: 'smooth' });
        });
      }
    });
  }

  if (loadURL) {
    fetch(loadURL).then(r => r.text()).then(h => {
      const p = new DOMParser().parseFromString(h, 'text/html');
      document.querySelector('.collectionSliderWrapper').innerHTML = p.querySelector('.collectionSliderWrapper').innerHTML;
      initializeSliders();
    });
  } else {
    initializeSliders();
  }
}
initProductRecommendationsAndSliders();